import { cva } from '@/styled-system/css';

export const photoCarouselNavButtonRecipe = cva({
  base: {
    'position': 'absolute',

    '&&': {
      height: '100%',
      color: 'icon.onHero.neutral-fixed',
    },

    '&&&:active, &&&:hover': {
      backgroundColor: 'transparent.invisible',
      color: 'icon.onHero.neutral-fixed',
    },

    '& > .c11n_icon': {
      filter: 'drop-shadow({shadows.PhotoCarousel.NavControls})',
    },
  },
  variants: {
    disabled: {
      false: {},
      true: {
        // CDS-2260: prevent clicking on disabled nav button from triggering Card's onClick
        pointerEvents: 'auto',
      },
    },
  },
});
